<template>
  <w-icon-wrapper
    :width='24'
    :height='19.2'
    icon-name='work-nav-notification-icon'
    view-box='0 0 24 19.2'
  >
    <path
      id="_06_Benachrichtigungen_Icon"
      data-name="06_Benachrichtigungen_Icon"
      d="M82.4-780.8a2.311,2.311,0,0,1-1.695-.705A2.311,2.311,0,0,1,80-783.2v-14.4a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,82.4-800h19.2a2.311,2.311,0,0,1,1.695.705,2.311,2.311,0,0,1,.705,1.7v14.4a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.695.705Zm9.6-8.4-9.6-6v12h19.2v-12Zm0-2.4,9.6-6H82.4Zm-9.6-3.6v0Z"
      transform="translate(-80 800)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavNotification' };
</script>

